'use strict';

const _ = require('lodash');
const uniqId = require('uniq-id');
const jQuery = require('jquery');

const Mediator = require('./../../core/mediator');
const Translator = require('./../../core/translator');

module.exports = function(FormBuilder, elements, config) {
  if (typeof FormBuilder !== 'object') {
    throw new Error('FormBuilder must be set in form constructor');
  }

  if (typeof elements !== 'object') {
    throw new Error('Elements must be set in form constructor');
  }

  let form = this;

  this.id = 'form_' + uniqId(null, 5);
  this.config = config || {};
  this.name = this.config.name || '';
  this.formClass = this.config.form_class || '';
  this.method = this.config.method || 'POST';
  this.errors = {};
  this.formError = this.config.error || '';

  this.listeners = {
    'submit': [],
    'validate': [],
    'tab:changed': [],
  };

  this.on = function(eventName, callback) {
    if (form.listeners[eventName]) {
      form.listeners[eventName].push(callback);
    }
  };

  this.dispatch = function(eventName, ...args) {
    let listeners;

    if (typeof eventName !== 'string') {
      throw new Error('Invalid event name');
    }

    listeners = form.listeners[eventName];

    if (listeners) {
      _.forEach(listeners, function(listener) {
        listener(...args);
      });
    }
  };

  this.submit = function() {
    let data = {};

    form.hideErrors();

    _.forEach(form.elements, function(element, key) {
      if ('function' === typeof element.getData && element.config.ignoreOnSubmit !== true) {
        let currentData = element.getData();
        if (null !== currentData) {
          data[key] = currentData;
        }
      }
    });

    form.dispatch('validate', data, form);

    if (0 === Object.keys(form.errors).length) {
      if (form.listeners.submit.length > 0) {
        form.dispatch('submit', data, form);
      } else {
        if (form.$) {
          form.$.submit();
        }
      }
    } else {
      form.displayErrors();
    }
  };

  this.hideErrors = function() {
    this.errors = {};

    if (form.$ instanceof jQuery) {
      form.$.find('.global-form-error')
        .addClass('d-none')
        .text('');
    }

    _.forEach(form.elements, function(element) {
      if (element && typeof element.hideError === 'function') {
        element.error = null;
        element.hideError();
      }
    });
  };

  this.displayErrors = function() {
    _.forEach(form.errors, function(error, key) {
      let element = form.elements[key];

      if (element !== undefined) {
        element.error = error;
        element.displayError();
      }
    });
  };

  this.addError = function(elementName, error) {
    if (undefined === form.errors[elementName]) {
      form.errors[elementName] = {};
    }

    form.errors[elementName] = error;
  };

  this.computeElements = function() {
    let submitConf;

    form.elements = {};

    _.forEach(elements, function(element, key) {
      let FbElement = FormBuilder.elements[element.type];

      if (undefined !== FbElement) {
        element.name = key;
        element.form = form;
        form.elements[key] = new FbElement(element);
      }
    });

    submitConf = {
      'form': form,
      'label': form.config.submit_label || 'Submit',
      'elementClass': form.config.submit_class,
      'wrapClass': form.config.submit_wrap_class,
    };

    form.elements.submit = new FormBuilder.elements.submit(submitConf);
  };

  this.renderElement = function(element, key) {
    let $wrap = jQuery('<div/>');
    let html;

    $wrap.addClass('element_' + key + (element.wrapClass ? ' ' + element.wrapClass : ''));

    html = element.render($wrap);

    if (undefined !== html) {
      $wrap.append(html);
    }

    if (typeof element.afterRender === 'function') {
      $wrap.append(element.afterRender());
    }

    element.$ = $wrap;

    if (key !== 'submit') {
      element.displayError();
    }

    return $wrap;
  };

  this.renderElements = function($form) {
    let tabUsed = false;
    let self = this;

    _.forEach(form.elements, (element, key) => {
      let config = element.config;
      let $element = this.renderElement(element, key);

      tabUsed = tabUsed || Boolean(config.tab);

      if (config.group) {
        let $group = $form.find(`.group.${config.group.id}`);

        if (!$group.length) {
          $group = jQuery(`<div class="group ${config.group.id} ${config.group.class || ''}"></div>`);
        }

        $group.append($element);
        $element = $group;

        if (config.group.description) {
          $group.prepend(`<p class="group-description">${Translator.translate(config.group.description)}</p>`);
        }

        if (config.group.title && !$group.find('.group-label').length) {
          $group.prepend(jQuery(`<label class="cloud-label group-label">${Translator.translate(config.group.title)}</label>`));
        }

        if (config.group.renderType === 'twoColumns') {
          $element.addClass('half-width');
        }
      }

      $form.append($element);
    });

    if (tabUsed) {
      let $menu = jQuery('<ul class="nav nav-tabs"></ul>');

      _.forEach(form.elements, (element, key) => {
        let config = element.config;
        let tab = config.tab || 'default';
        let titleTab = Translator.translate(tab);
        let $tab = $form.find(`.tab.cloud-${tab}`);

        if ($menu.find(`li.cloud-${tab}`).length === 0) {
          let $li = jQuery(`<li data-tab="${tab}" class="cloud-${tab} nav-item"><a href="#" class="nav-link">${titleTab}</a></li>`);

          $li.on('click', function(event) {
            let $target = jQuery(this);
            let currentTab = $target.data('tab');

            $form.find('.tab').addClass('d-none');
            $form.find(`.tab.cloud-${currentTab}`).removeClass('d-none');

            $target.siblings('.active').removeClass('active');
            $target.addClass('active');

            if (typeof self.config.onChangeTab === 'function') {
              self.config.onChangeTab(currentTab);
            }

            form.dispatch('tab:changed', currentTab);

            event.preventDefault();
          });

          $menu.append($li);
        }

        if (!$tab.length) {
          $tab = jQuery(`<div class="tab cloud-${tab} d-none"></div>`);

          $form.append($tab);
        }

        if (config['tab_focus']) {
          $tab.attr('data-tab-focus', true);
          $tab.removeClass('d-none');
          $menu.find(`li.cloud-${tab}`).addClass('active');
        }

        if (config.group) {
          if (!$tab.find(`.group.${config.group.id}`).length) {
            let $group = $form.find(`.group.${config.group.id}`);
            $group.appendTo($tab);
          }
        } else if (key !== 'submit') {
          $form.find(`.element_${key}`).appendTo($tab);
        }
      });

      if (!$form.find('.tab.cloud-default').children().length) {
        $form.find('.tab.cloud-default').remove();
        $menu.find('li.cloud-default').remove();
      }

      if (!$form.find('[data-tab-focus="true"]').length) {
        $form.find('.tab:first').removeClass('d-none');
        $menu.find('li:first').addClass('active');
      }

      $form.prepend($menu);
    }
  };

  this.reset = () => {
    this.$.replaceWith(this.render());
  };

  this.addFormError = function(error) {
    if (error) {
      form.formError = error;

      if (form.$ instanceof jQuery) {
        form.$.find('.global-form-error')
          .removeClass('d-none')
          .text(error);
      }
    }
  };

  this.render = function() {
    let $form = jQuery(`<form class="${this.formClass}"/>`);
    let $error = jQuery('<span/>');

    if (form.formClass) {
      $form.className = form.formClass;
    }

    if (config && config.autocomplete === false) {
      $form.attr('autocomplete', 'off');
    }

    $form.attr('method', form.method);
    $form.attr('id', form.id);
    $error.addClass('global-form-error d-none');

    this.addFormError(form.formError);

    $form.append($error);

    if (form.name) {
      $form.attr('name', form.name);
    }

    form.renderElements($form);

    form.$ = $form;

    Mediator.publish('after:form:render', form);

    return form.$;
  };

  (function() {
    form.computeElements();
  }());

  return form;
};
